export enum InvoiceCustomerDisplayField {
  YOUR_REFERENCE = "YOUR_REFERENCE",
  OUR_REFERENCE = "OUR_REFERENCE",
  ORG_NUMBER = "ORG_NUMBER",
  EMAIL = "EMAIL",
  PHONE = "PHONE",
  CITY = "CITY",
  ADDRESS1 = "ADDRESS1",
  CUSTOMER_NUMBER = "CUSTOMER_NUMBER",
}
